import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_wildsky_common_proto from './dcei_wildsky_common_proto';
class HelpNavigationData_NavigationItemDefinition {
  get descriptor() {
    return HelpNavigationData_NavigationItemDefinition.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasDisplayName = false;
    this._displayName = null;
    this._hasEntry = false;
    this._entry = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasDisplayName) return false;
    if (this._hasEntry && !this._entry.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof HelpNavigationData_NavigationItemDefinition) {
      return value;
    }
    return HelpNavigationData_NavigationItemDefinition.fromJson(value);
  }
  static fromJson(json) {
    const result = new HelpNavigationData_NavigationItemDefinition();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.displayName != null) {
      result._hasDisplayName = true;
      result._displayName = JsonToString.fromJson(json.displayName);
    }
    if (json.entry != null) {
      result._hasEntry = true;
      result._entry = dcei_wildsky_common_proto.PageNavigationEntry.fromJson(json.entry);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasDisplayName) {
      result.displayName = JsonToString.toJson(this._displayName);
    }
    if (this._hasEntry && !this._entry.isEmpty()) {
      result.entry = dcei_wildsky_common_proto.PageNavigationEntry.toJson(this._entry);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {string}
   */
  get displayName() {
    return this._hasDisplayName ? this._displayName : JsonToString.default;
  }
  get hasDisplayName() {
    return this._hasDisplayName;
  }
  setDisplayName(path, value) {
    return {type: 'SET', path: path.concat(['displayName']), value};
  }
  deleteDisplayName(path) {
    return {type: 'DELETE', path: path.concat(['displayName'])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.PageNavigationEntry}
   */
  get entry() {
    return this._hasEntry ? this._entry : dcei_wildsky_common_proto.PageNavigationEntry.default;
  }
  get hasEntry() {
    return this._hasEntry;
  }
  setEntry(path, value) {
    return {type: 'SET', path: path.concat(['entry']), value: value.toJson()};
  }
  deleteEntry(path) {
    return {type: 'DELETE', path: path.concat(['entry'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new HelpNavigationData_NavigationItemDefinition(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new HelpNavigationData_NavigationItemDefinition(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "displayName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new HelpNavigationData_NavigationItemDefinition(this);
              copy._hasDisplayName = true;
              copy._displayName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayName) {
                return this;
              }
              const copy = new HelpNavigationData_NavigationItemDefinition(this);
              copy._hasDisplayName = false;
              copy._displayName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "entry": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new HelpNavigationData_NavigationItemDefinition(this);
              copy._hasEntry = true;
              copy._entry = dcei_wildsky_common_proto.PageNavigationEntry.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEntry) {
                return this;
              }
              const copy = new HelpNavigationData_NavigationItemDefinition(this);
              copy._hasEntry = false;
              copy._entry = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasEntry) {
            const copy = new HelpNavigationData_NavigationItemDefinition(this);
            copy._hasEntry = true;
            copy._entry = dcei_wildsky_common_proto.PageNavigationEntry.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._entry.apply(type, path.slice(1), value);
          if (newValue === this._entry) {
            return this;
          }
          const copy = new HelpNavigationData_NavigationItemDefinition(this);
          copy._entry = copy._entry.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {HelpNavigationData_NavigationItemDefinition} other
   * @returns {HelpNavigationData_NavigationItemDefinition}
   */
  merge(other) {
    const copy = new HelpNavigationData_NavigationItemDefinition(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasDisplayName) {
      copy._hasDisplayName = true;
      copy._displayName = other._displayName;
    }
    if (other._hasEntry) {
      if (copy._hasEntry) {
        copy._entry = copy.entry.merge(other.entry);
      } else {
        copy._entry = other._entry;
      }
      copy._hasEntry = true;
    }
    return copy;
  }
}
HelpNavigationData_NavigationItemDefinition.default = new HelpNavigationData_NavigationItemDefinition();
class HelpNavigationData_NavigationItemDefinition_Builder {
  constructor(value) {
    this._value = new HelpNavigationData_NavigationItemDefinition(value);
  }
  build() {
    return new HelpNavigationData_NavigationItemDefinition(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setDisplayName(value) {
    this._value._hasDisplayName = true;
    this._value._displayName = value;
    return this;
  }
  deleteDisplayName() {
    this._value._hasDisplayName = false;
    this._value._displayName = null;
    return this;
  }
  setEntry(value) {
    this._value._hasEntry = true;
    this._value._entry = value;
    return this;
  }
  deleteEntry() {
    this._value._hasEntry = false;
    this._value._entry = null;
    return this;
  }
}
HelpNavigationData_NavigationItemDefinition.Builder = HelpNavigationData_NavigationItemDefinition_Builder;
class HelpNavigationData_NavigationItemDefinition_WithParent {
  /**
   * @param {HelpNavigationData_NavigationItemDefinition} value
   * @param {HelpNavigationData_NavigationItemDefinition_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return HelpNavigationData_NavigationItemDefinition.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasDisplayName() {
    if (this._cachedHasDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedHasDisplayName = true;
      } else {
        this._cachedHasDisplayName = this._parent ? this._parent.hasDisplayName : false;
      }
    }
    return this._cachedHasDisplayName;
  }
  get displayName() {
    if (this._cachedDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedDisplayName = this._value.displayName;
      } else {
        this._cachedDisplayName = this._parent ? this._parent.displayName : this._value.displayName;
      }
    }
    return this._cachedDisplayName;
  }
  get hasEntry() {
    if (this._cachedHasEntry === undefined) {
      if (this._value.hasEntry) {
        this._cachedHasEntry = true;
      } else {
        this._cachedHasEntry = this._parent ? this._parent.hasEntry : false;
      }
    }
    return this._cachedHasEntry;
  }
  get entry() {
    if (!this._cachedEntry) {
      if (this._value.hasEntry) {
        this._cachedEntry = new dcei_wildsky_common_proto.PageNavigationEntry.WithParent(this._value.entry, this._parent && this._parent.hasEntry ? this._parent.entry : null);
      } else {
        this._cachedEntry = this._parent ? new dcei_wildsky_common_proto.PageNavigationEntry.WithParent(dcei_wildsky_common_proto.PageNavigationEntry.default, this._parent.entry) : dcei_wildsky_common_proto.PageNavigationEntry.WithParent.default;
      }
    }
    return this._cachedEntry;
  }
  update(current, parent) {
    const result = new HelpNavigationData_NavigationItemDefinition_WithParent(current, parent);
    if (this._cachedEntry && this._value.hasEntry && current.hasEntry) {
      if (this._value.entry === current.entry && this._parent === parent) {
        result._cachedEntry = this._cachedEntry;
      } else {
        result._cachedEntry = this._cachedEntry.update(current.entry, parent && parent.hasEntry ? parent.entry : null);
      }
    }
    return result;
  }
}
HelpNavigationData_NavigationItemDefinition_WithParent.default = new HelpNavigationData_NavigationItemDefinition_WithParent(HelpNavigationData_NavigationItemDefinition.default, null);
HelpNavigationData_NavigationItemDefinition.WithParent = HelpNavigationData_NavigationItemDefinition_WithParent;
class HelpNavigationData_NavigationItemDefinition_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get displayName() {
    if (!this._displayName) {
      this._displayName = {
        name: "displayName",
        Name: "DisplayName",
        number: 2,
        protoType: 9,
        protoName: "display_name",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayName;
  }
  get entry() {
    if (!this._entry) {
      this._entry = {
        name: "entry",
        Name: "Entry",
        number: 3,
        protoType: 11,
        protoName: "entry",
        type: dcei_wildsky_common_proto.PageNavigationEntry,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._entry;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.displayName,
        this.entry,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayName",
        Name: "DummyOneofForDisplayName",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEntry",
        Name: "DummyOneofForEntry",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
HelpNavigationData_NavigationItemDefinition.descriptor = new HelpNavigationData_NavigationItemDefinition_Descriptor();
class HelpNavigationData_NavigationSlot {
  get descriptor() {
    return HelpNavigationData_NavigationSlot.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasDisplayName = false;
    this._displayName = null;
    this._navigationItemKeys = [];
  }
  isEmpty() {
    if (this._hasDisplayName) return false;
    if (this._navigationItemKeys.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof HelpNavigationData_NavigationSlot) {
      return value;
    }
    return HelpNavigationData_NavigationSlot.fromJson(value);
  }
  static fromJson(json) {
    const result = new HelpNavigationData_NavigationSlot();
    if (json.displayName != null) {
      result._hasDisplayName = true;
      result._displayName = JsonToString.fromJson(json.displayName);
    }
    result._navigationItemKeys = JsonToList(json.navigationItemKeys, JsonToString);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasDisplayName) {
      result.displayName = JsonToString.toJson(this._displayName);
    }
    if (this._navigationItemKeys.length > 0) {
      result.navigationItemKeys = ArrayToJson(this._navigationItemKeys, JsonToString);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get displayName() {
    return this._hasDisplayName ? this._displayName : JsonToString.default;
  }
  get hasDisplayName() {
    return this._hasDisplayName;
  }
  setDisplayName(path, value) {
    return {type: 'SET', path: path.concat(['displayName']), value};
  }
  deleteDisplayName(path) {
    return {type: 'DELETE', path: path.concat(['displayName'])};
  }
  /**
   * @returns {string[]}
   */
  get navigationItemKeys() {
    return this._navigationItemKeys;
  }
  addNavigationItemKeys(path, value) {
    return {type: 'ADD', path: path.concat(['navigationItemKeys']), value};
  }
  setNavigationItemKeys(path, value) {
    return {type: 'SET', path: path.concat(['navigationItemKeys']), value: ArrayToJson(value, JsonToString)};
  }
  setNavigationItemKeysByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['navigationItemKeys', key]), value};
  }
  deleteNavigationItemKeys(path) {
    return {type: 'DELETE', path: path.concat(['navigationItemKeys'])};
  }
  deleteNavigationItemKeysByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['navigationItemKeys', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "displayName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new HelpNavigationData_NavigationSlot(this);
              copy._hasDisplayName = true;
              copy._displayName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayName) {
                return this;
              }
              const copy = new HelpNavigationData_NavigationSlot(this);
              copy._hasDisplayName = false;
              copy._displayName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "navigationItemKeys": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new HelpNavigationData_NavigationSlot(this);
              copy._navigationItemKeys = [];        for (let i of value) {
                copy._navigationItemKeys.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new HelpNavigationData_NavigationSlot(this);
              copy._navigationItemKeys = copy._navigationItemKeys.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._navigationItemKeys.length === 0) {
                return this;
              }
              const copy = new HelpNavigationData_NavigationSlot(this);
              copy._navigationItemKeys = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._navigationItemKeys.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new HelpNavigationData_NavigationSlot(this);
              copy._navigationItemKeys = copy._navigationItemKeys.slice();
              copy._navigationItemKeys[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new HelpNavigationData_NavigationSlot(this);
              copy._navigationItemKeys = copy._navigationItemKeys.slice(0, path[1]).concat(copy._navigationItemKeys.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._navigationItemKeys.length) {
            return this;
          }
          const oldValue = this._navigationItemKeys[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new HelpNavigationData_NavigationSlot(this);
          copy._navigationItemKeys = copy._navigationItemKeys.slice();
          copy._navigationItemKeys[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {HelpNavigationData_NavigationSlot} other
   * @returns {HelpNavigationData_NavigationSlot}
   */
  merge(other) {
    const copy = new HelpNavigationData_NavigationSlot(this);
    if (other._hasDisplayName) {
      copy._hasDisplayName = true;
      copy._displayName = other._displayName;
    }
    copy._navigationItemKeys = this._navigationItemKeys.concat(other._navigationItemKeys);
    return copy;
  }
}
HelpNavigationData_NavigationSlot.default = new HelpNavigationData_NavigationSlot();
class HelpNavigationData_NavigationSlot_Builder {
  constructor(value) {
    this._value = new HelpNavigationData_NavigationSlot(value);
  }
  build() {
    return new HelpNavigationData_NavigationSlot(this._value);
  }
  setDisplayName(value) {
    this._value._hasDisplayName = true;
    this._value._displayName = value;
    return this;
  }
  deleteDisplayName() {
    this._value._hasDisplayName = false;
    this._value._displayName = null;
    return this;
  }
  addAllNavigationItemKeys(values) {
    this._value._navigationItemKeys = this._value._navigationItemKeys.concat(values);
    return this;
  }
  addNavigationItemKeys(value) {
    this._value._navigationItemKeys = this._value._navigationItemKeys.concat([value]);
    return this;
  }
  setNavigationItemKeys(index, value) {
    this._value._navigationItemKeys = this._value._navigationItemKeys.concat();
    this._value._navigationItemKeys[index] = value;
    return this;
  }
  clearNavigationItemKeys() {
    this._value._navigationItemKeys = [];
    return this;
  }
}
HelpNavigationData_NavigationSlot.Builder = HelpNavigationData_NavigationSlot_Builder;
class HelpNavigationData_NavigationSlot_WithParent {
  /**
   * @param {HelpNavigationData_NavigationSlot} value
   * @param {HelpNavigationData_NavigationSlot_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return HelpNavigationData_NavigationSlot.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasDisplayName() {
    if (this._cachedHasDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedHasDisplayName = true;
      } else {
        this._cachedHasDisplayName = this._parent ? this._parent.hasDisplayName : false;
      }
    }
    return this._cachedHasDisplayName;
  }
  get displayName() {
    if (this._cachedDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedDisplayName = this._value.displayName;
      } else {
        this._cachedDisplayName = this._parent ? this._parent.displayName : this._value.displayName;
      }
    }
    return this._cachedDisplayName;
  }
  get selfNavigationItemKeys() {
    return this._value.navigationItemKeys;
  }
  get inherentNavigationItemKeys() {
    if (!this._inherentNavigationItemKeys) {
      this._inherentNavigationItemKeys = this._parent ? this._parent.navigationItemKeys : [];
    }
    return this._inherentNavigationItemKeys;
  }
  get navigationItemKeys() {
    if (!this._allNavigationItemKeys) {
      this._allNavigationItemKeys = this._parent ? this._parent.navigationItemKeys.concat(this.selfNavigationItemKeys) : this.selfNavigationItemKeys;
    }
    return this._allNavigationItemKeys;
  }
  update(current, parent) {
    const result = new HelpNavigationData_NavigationSlot_WithParent(current, parent);
    return result;
  }
}
HelpNavigationData_NavigationSlot_WithParent.default = new HelpNavigationData_NavigationSlot_WithParent(HelpNavigationData_NavigationSlot.default, null);
HelpNavigationData_NavigationSlot.WithParent = HelpNavigationData_NavigationSlot_WithParent;
class HelpNavigationData_NavigationSlot_Descriptor {
  get displayName() {
    if (!this._displayName) {
      this._displayName = {
        name: "displayName",
        Name: "DisplayName",
        number: 1,
        protoType: 9,
        protoName: "display_name",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayName;
  }
  get navigationItemKeys() {
    if (!this._navigationItemKeys) {
      this._navigationItemKeys = {
        name: "navigationItemKeys",
        Name: "NavigationItemKeys",
        number: 2,
        protoType: 9,
        protoName: "navigation_item_keys",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "HelpNavigationItems",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._navigationItemKeys;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.displayName,
        this.navigationItemKeys,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDisplayName",
        Name: "DummyOneofForDisplayName",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
HelpNavigationData_NavigationSlot.descriptor = new HelpNavigationData_NavigationSlot_Descriptor();
export class HelpNavigationData {
  get descriptor() {
    return HelpNavigationData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._navigationItemDefinitions = [];
    this._navigationSlots = [];
  }
  isEmpty() {
    if (this._navigationItemDefinitions.length > 0) return false;
    if (this._navigationSlots.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof HelpNavigationData) {
      return value;
    }
    return HelpNavigationData.fromJson(value);
  }
  static fromJson(json) {
    const result = new HelpNavigationData();
    result._navigationItemDefinitions = JsonToList(json.navigationItemDefinitions, HelpNavigationData_NavigationItemDefinition);
    result._navigationSlots = JsonToList(json.navigationSlots, HelpNavigationData_NavigationSlot);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._navigationItemDefinitions.length > 0) {
      result.navigationItemDefinitions = ArrayToJson(this._navigationItemDefinitions, HelpNavigationData_NavigationItemDefinition);
    }
    if (this._navigationSlots.length > 0) {
      result.navigationSlots = ArrayToJson(this._navigationSlots, HelpNavigationData_NavigationSlot);
    }
    return result;
  }
  /**
   * @returns {HelpNavigationData_NavigationItemDefinition[]}
   */
  get navigationItemDefinitions() {
    return this._navigationItemDefinitions;
  }
  addNavigationItemDefinitions(path, value) {
    return {type: 'ADD', path: path.concat(['navigationItemDefinitions']), value: value.toJson()};
  }
  setNavigationItemDefinitions(path, value) {
    return {type: 'SET', path: path.concat(['navigationItemDefinitions']), value: ArrayToJson(value, HelpNavigationData_NavigationItemDefinition)};
  }
  setNavigationItemDefinitionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['navigationItemDefinitions', key]), value: value.toJson()};
  }
  deleteNavigationItemDefinitions(path) {
    return {type: 'DELETE', path: path.concat(['navigationItemDefinitions'])};
  }
  deleteNavigationItemDefinitionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['navigationItemDefinitions', key])};
  }
  /**
   * @returns {HelpNavigationData_NavigationSlot[]}
   */
  get navigationSlots() {
    return this._navigationSlots;
  }
  addNavigationSlots(path, value) {
    return {type: 'ADD', path: path.concat(['navigationSlots']), value: value.toJson()};
  }
  setNavigationSlots(path, value) {
    return {type: 'SET', path: path.concat(['navigationSlots']), value: ArrayToJson(value, HelpNavigationData_NavigationSlot)};
  }
  setNavigationSlotsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['navigationSlots', key]), value: value.toJson()};
  }
  deleteNavigationSlots(path) {
    return {type: 'DELETE', path: path.concat(['navigationSlots'])};
  }
  deleteNavigationSlotsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['navigationSlots', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "navigationItemDefinitions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new HelpNavigationData(this);
              copy._navigationItemDefinitions = [];        for (let i of value) {
                copy._navigationItemDefinitions.push(HelpNavigationData_NavigationItemDefinition.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new HelpNavigationData(this);
              copy._navigationItemDefinitions = copy._navigationItemDefinitions.concat([HelpNavigationData_NavigationItemDefinition.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._navigationItemDefinitions.length === 0) {
                return this;
              }
              const copy = new HelpNavigationData(this);
              copy._navigationItemDefinitions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._navigationItemDefinitions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new HelpNavigationData(this);
              copy._navigationItemDefinitions = copy._navigationItemDefinitions.slice();
              copy._navigationItemDefinitions[path[1]] = HelpNavigationData_NavigationItemDefinition.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new HelpNavigationData(this);
              copy._navigationItemDefinitions = copy._navigationItemDefinitions.slice(0, path[1]).concat(copy._navigationItemDefinitions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._navigationItemDefinitions.length) {
            return this;
          }
          const oldValue = this._navigationItemDefinitions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new HelpNavigationData(this);
          copy._navigationItemDefinitions = copy._navigationItemDefinitions.slice();
          copy._navigationItemDefinitions[key] = newValue;
          return copy;
        }
      }
      case "navigationSlots": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new HelpNavigationData(this);
              copy._navigationSlots = [];        for (let i of value) {
                copy._navigationSlots.push(HelpNavigationData_NavigationSlot.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new HelpNavigationData(this);
              copy._navigationSlots = copy._navigationSlots.concat([HelpNavigationData_NavigationSlot.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._navigationSlots.length === 0) {
                return this;
              }
              const copy = new HelpNavigationData(this);
              copy._navigationSlots = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._navigationSlots.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new HelpNavigationData(this);
              copy._navigationSlots = copy._navigationSlots.slice();
              copy._navigationSlots[path[1]] = HelpNavigationData_NavigationSlot.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new HelpNavigationData(this);
              copy._navigationSlots = copy._navigationSlots.slice(0, path[1]).concat(copy._navigationSlots.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._navigationSlots.length) {
            return this;
          }
          const oldValue = this._navigationSlots[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new HelpNavigationData(this);
          copy._navigationSlots = copy._navigationSlots.slice();
          copy._navigationSlots[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {HelpNavigationData} other
   * @returns {HelpNavigationData}
   */
  merge(other) {
    const copy = new HelpNavigationData(this);
    copy._navigationItemDefinitions = this._navigationItemDefinitions.concat(other._navigationItemDefinitions);
    copy._navigationSlots = this._navigationSlots.concat(other._navigationSlots);
    return copy;
  }
}
HelpNavigationData.default = new HelpNavigationData();
HelpNavigationData.NavigationItemDefinition = HelpNavigationData_NavigationItemDefinition;
HelpNavigationData.NavigationSlot = HelpNavigationData_NavigationSlot;
class HelpNavigationData_Builder {
  constructor(value) {
    this._value = new HelpNavigationData(value);
  }
  build() {
    return new HelpNavigationData(this._value);
  }
  addAllNavigationItemDefinitions(values) {
    this._value._navigationItemDefinitions = this._value._navigationItemDefinitions.concat(values);
    return this;
  }
  addNavigationItemDefinitions(value) {
    this._value._navigationItemDefinitions = this._value._navigationItemDefinitions.concat([value]);
    return this;
  }
  setNavigationItemDefinitions(index, value) {
    this._value._navigationItemDefinitions = this._value._navigationItemDefinitions.concat();
    this._value._navigationItemDefinitions[index] = value;
    return this;
  }
  clearNavigationItemDefinitions() {
    this._value._navigationItemDefinitions = [];
    return this;
  }
  addAllNavigationSlots(values) {
    this._value._navigationSlots = this._value._navigationSlots.concat(values);
    return this;
  }
  addNavigationSlots(value) {
    this._value._navigationSlots = this._value._navigationSlots.concat([value]);
    return this;
  }
  setNavigationSlots(index, value) {
    this._value._navigationSlots = this._value._navigationSlots.concat();
    this._value._navigationSlots[index] = value;
    return this;
  }
  clearNavigationSlots() {
    this._value._navigationSlots = [];
    return this;
  }
}
HelpNavigationData.Builder = HelpNavigationData_Builder;
class HelpNavigationData_WithParent {
  /**
   * @param {HelpNavigationData} value
   * @param {HelpNavigationData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return HelpNavigationData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfNavigationItemDefinitions() {
    if (!this._selfNavigationItemDefinitions) {
      this._selfNavigationItemDefinitions = [];
      for (let i of this._value.navigationItemDefinitions) {
        this._selfNavigationItemDefinitions.push(new HelpNavigationData_NavigationItemDefinition.WithParent(i, null));
      }
    }
    return this._selfNavigationItemDefinitions;
  }
  get inherentNavigationItemDefinitions() {
    if (!this._inherentNavigationItemDefinitions) {
      this._inherentNavigationItemDefinitions = this._parent ? this._parent.navigationItemDefinitions : [];
    }
    return this._inherentNavigationItemDefinitions;
  }
  get navigationItemDefinitions() {
    if (!this._allNavigationItemDefinitions) {
      this._allNavigationItemDefinitions = this._parent ? this._parent.navigationItemDefinitions.concat(this.selfNavigationItemDefinitions) : this.selfNavigationItemDefinitions;
    }
    return this._allNavigationItemDefinitions;
  }
  get selfNavigationSlots() {
    if (!this._selfNavigationSlots) {
      this._selfNavigationSlots = [];
      for (let i of this._value.navigationSlots) {
        this._selfNavigationSlots.push(new HelpNavigationData_NavigationSlot.WithParent(i, null));
      }
    }
    return this._selfNavigationSlots;
  }
  get inherentNavigationSlots() {
    if (!this._inherentNavigationSlots) {
      this._inherentNavigationSlots = this._parent ? this._parent.navigationSlots : [];
    }
    return this._inherentNavigationSlots;
  }
  get navigationSlots() {
    if (!this._allNavigationSlots) {
      this._allNavigationSlots = this._parent ? this._parent.navigationSlots.concat(this.selfNavigationSlots) : this.selfNavigationSlots;
    }
    return this._allNavigationSlots;
  }
  update(current, parent) {
    const result = new HelpNavigationData_WithParent(current, parent);
    if (this._selfNavigationItemDefinitions) {
      if (this._value.navigationItemDefinitions === current.navigationItemDefinitions) {
        result._selfNavigationItemDefinitions = this._selfNavigationItemDefinitions;
      } else {
        result._selfNavigationItemDefinitions = [];
        for (let i = 0; i < current.navigationItemDefinitions.length; i++) {
          const oldValue = this._value.navigationItemDefinitions[i];
          if (oldValue) {
            const oldCache = this._selfNavigationItemDefinitions[i];
            if (oldValue === current.navigationItemDefinitions[i]) {
              result._selfNavigationItemDefinitions[i] = oldCache;
            } else {
              result._selfNavigationItemDefinitions[i] = oldCache.update(current.navigationItemDefinitions[i], null);
            }
          } else {
            result._selfNavigationItemDefinitions[i] = new HelpNavigationData_NavigationItemDefinition.WithParent(current.navigationItemDefinitions[i], null);
          }
        }
      }
    }
    if (this._selfNavigationSlots) {
      if (this._value.navigationSlots === current.navigationSlots) {
        result._selfNavigationSlots = this._selfNavigationSlots;
      } else {
        result._selfNavigationSlots = [];
        for (let i = 0; i < current.navigationSlots.length; i++) {
          const oldValue = this._value.navigationSlots[i];
          if (oldValue) {
            const oldCache = this._selfNavigationSlots[i];
            if (oldValue === current.navigationSlots[i]) {
              result._selfNavigationSlots[i] = oldCache;
            } else {
              result._selfNavigationSlots[i] = oldCache.update(current.navigationSlots[i], null);
            }
          } else {
            result._selfNavigationSlots[i] = new HelpNavigationData_NavigationSlot.WithParent(current.navigationSlots[i], null);
          }
        }
      }
    }
    return result;
  }
}
HelpNavigationData_WithParent.default = new HelpNavigationData_WithParent(HelpNavigationData.default, null);
HelpNavigationData.WithParent = HelpNavigationData_WithParent;
class HelpNavigationData_Descriptor {
  get navigationItemDefinitions() {
    if (!this._navigationItemDefinitions) {
      this._navigationItemDefinitions = {
        name: "navigationItemDefinitions",
        Name: "NavigationItemDefinitions",
        number: 1,
        protoType: 11,
        protoName: "navigation_item_definitions",
        type: HelpNavigationData_NavigationItemDefinition,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._navigationItemDefinitions;
  }
  get navigationSlots() {
    if (!this._navigationSlots) {
      this._navigationSlots = {
        name: "navigationSlots",
        Name: "NavigationSlots",
        number: 2,
        protoType: 11,
        protoName: "navigation_slots",
        type: HelpNavigationData_NavigationSlot,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._navigationSlots;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.navigationItemDefinitions,
        this.navigationSlots,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
HelpNavigationData.descriptor = new HelpNavigationData_Descriptor();
